import clsx from "clsx";
import type { CSSProperties } from "react";
import type { IColorable } from "../types";
import IconStyle from "./icon.module.scss";
import { getColor } from "../../scss";

export interface IconProps extends Omit<IColorable, "bgColor"> {
  className?: string;
  style?: CSSProperties;
  icon: string;
  size?: number;
  onClick?: (event?: any) => void;
  pathNumber?: number;
  id?: string;
}

const Icon = (props: IconProps) => {
  const {
    className,
    color,
    style,
    icon,
    size,
    onClick,
    pathNumber = 0,
    id,
  } = props;

  const styles = {
    fontSize: `${size}rem`,
    color: getColor(color),
    ...style,
  };

  return (
    <span
      id={id}
      onClick={onClick}
      style={styles}
      className={clsx("mi", IconStyle["icon"], icon, className)}
    >
      {!!pathNumber &&
        new Array(pathNumber).fill(pathNumber).map((item, index) => (
          <span key={index}>
            <span className={clsx(icon, `path${index + 1}`)} />
            <style>{`
                .${icon}.path${index + 1}::before {
                  color: ${getColor(color)};
                }
              `}</style>
          </span>
        ))}
    </span>
  );
};

export default Icon;
